import { domain } from 'modules/data';

export const excludedKeys: (keyof domain.QBooksSalesInvoiceShipping)[] = ['price', 'priceGross'];
